import React from "react";
import { styled } from "@stitches/react";
import SortDefault from "@/components/Icons/sort-default";
import SortAsc from "@/components/Icons/sort-ascending";
import SortDesc from "@/components/Icons/sort-descending";
import { SortOrder } from "@/types/order-table";

const Wrapper = styled("button", {
  background: "none",
  border: "none",
  paddingLeft: 14,
  paddingRight: 7,
  display: "flex",
  justifyContent: "center",

  "&:hover": {
    cursor: "pointer",
  },

  variants: {
    active: {
      true: {
        "& path": {
          stroke: "#7c7d7d",
        },
      },
    },
  },
});

interface Props {
  sortOrder: SortOrder;
  onIconClick: React.MouseEventHandler<HTMLButtonElement>;
}

const SortIcon = ({ sortOrder, onIconClick }: Props) => (
  <Wrapper onClick={onIconClick} active={sortOrder !== null}>
    {sortOrder === null ? (
      <SortDefault />
    ) : sortOrder === "ASC" ? (
      <SortAsc />
    ) : (
      <SortDesc />
    )}
  </Wrapper>
);

export default SortIcon;
